"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableSizeDropdown = void 0;
var react_1 = __importStar(require("react"));
var Button_1 = require("../../Button");
var Dropdown_1 = require("../../Dropdown");
var Icon_1 = require("../../Icon");
var Text_1 = require("../../Text");
function TableSizeDropdown(props) {
    var options = props.options, size = props.size, onChange = props.onChange;
    var _a = react_1.useState(), buttonRef = _a[0], setButtonRef = _a[1];
    var _b = react_1.useState(false), open = _b[0], setOpen = _b[1];
    var handleChange = function (option) { return function () {
        onChange(option);
    }; };
    var handleClick = function () { return setOpen(function (state) { return !state; }); };
    var handleClose = function () {
        setOpen(false);
        buttonRef.focus();
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Button_1.Button, { innerRef: setButtonRef, onClick: handleClick, size: 'small', skin: 'ghost', style: { padding: '0 0.25rem' } },
            react_1.default.createElement(Text_1.Text, null, size),
            react_1.default.createElement(Icon_1.Icon, { icon: 'angleDown', style: { marginLeft: '0.125rem' } })),
        react_1.default.createElement(Dropdown_1.Dropdown, { anchorRef: buttonRef, open: open, onClose: handleClose }, options.map(function (op) { return (react_1.default.createElement(Dropdown_1.DropdownItem, { key: op, onClick: handleChange(op) }, op)); }))));
}
exports.TableSizeDropdown = TableSizeDropdown;
//# sourceMappingURL=TableSizeDropdown.js.map